<template>
    <div>
        <div class="changePassWrapper">
            <div class="ui raised very padded left aligned text container segment">
                <h1 class="ui center aligned header">Restablece tu contraseña</h1>
                <div class="ui form warning">
                    <sui-form-field error v-show="inputErr">
                        <label>Correo electrónico</label>
                        <input placeholder="Introduce tu correo electrónico" type="text" v-model="email" :disabled="disable"/>
                    </sui-form-field>
                    <sui-form-field v-show="!inputErr">
                        <label>Correo electrónico</label>
                        <input placeholder="tucorreo@blucapital.mx" type="text" v-model="email" v-value="email"  :disabled="disable"/>
                    </sui-form-field>
                    <div class="ui positive message" v-show="showSuccess">
                        <div class="header">¡Revisa tu correo!</div>
                        <ul class="list">
                        <li>Te enviamos un correo electrónico con las instrucciones para restablecer tu contraseña.</li>
                        </ul>
                    </div>
                    <div class="ui negative message" v-show="showErrAlert">
                        <div class="header">Error</div>
                        <ul class="list">
                        <li>{{this.errorMsg}}</li>
                        </ul>
                    </div>
                    <div class="ui centered grid">
                        <div class="column middle aligned">
                            <button
                                class="ui blue right labeled icon button"
                                type="submit"
                                :disabled="disable"
                                v-show="!loadingBtn"
                                @click="onSubmit"
                                >
                                <i class="paper plane icon"></i>
                                Enviar correo
                            </button>
                            <button class="ui blue loading button" disabled="true" v-show="loadingBtn"><i class="paper plane icon"></i>Enviar correo</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from '@/services/UserService'

export default {
    name: 'ForgotPassword',
    data () {
        return {
            email: undefined,
            inputErr: false,
            showErrAlert: false,
            disable: false,
            showSuccess: false,
            loadingBtn: false,
            errorMsg: ''
        }
    },
    methods: {
        async onSubmit () {
            this.showSuccess = false
            this.showErrAlert = false
            if (!this.email) {
                this.inputErr = true
            } else {
                this.inputErr = false
                try {
                    this.disable = true
                    this.loadingBtn = true
                    const success = await UserService.sendResetLink(this.email)
                    this.disable = false
                    this.loadingBtn = false
                    if (success) this.showSuccess = true
                    else {
                        this.errorMsg = 'Ocurrió un problema, por favor intenta más tarde.'
                        this.showErrAlert = true
                    }
                } catch (e) {
                    this.disable = false
                    this.loadingBtn = false
                    this.errorMsg = 'No existe ningún usuario registrado con este correo.'
                    this.showErrAlert = true
                }
            }
        }
    }
}
</script>

<style scoped>
.changePassWrapper {
    height: 100vh;
    align-content: center;
    display: grid;
    background: url(/pattern.png);
}
</style>
